import React, { useState, useRef, useEffect } from 'react';
import { Button, message } from 'antd';
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'

import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';

import { getUrlByFileAPI } from '@/server/airportCamera.js'

import ly_t from "@/common/img/airport_surveillance/AudioRecorder/ly_t.svg" // 开始_录音
import ly_f from "@/common/img/airport_surveillance/AudioRecorder/ly_f.svg" // 结束_录音


const AudioRecorder = (list) => {
  const token = localStorage.getItem('dock_token');
  const loading = list.isLoading
  console.log('type===2', loading);
  const [isRecording, setIsRecording] = useState(false);
  const [audioURL, setAudioURL] = useState('');
  const [recordingTime, setRecordingTime] = useState(0);
  const recordingTimeRef = useRef(0)
  const MAX_RECORDING_TIME = 3000; // 最大录音时长（毫秒*1）
  const mediaRecorder = useRef(null)
  const audioChunks = useRef([])
  const canvasRef = useRef(null)
  const animationRef = useRef(null)
  const audioContextRef = useRef(null)
  const analyserRef = useRef(null)

  const startRecording = async () => {// 开始录音
    list.returnBack('')
    localStorage.setItem('megaphoneTime', 0)
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorder.current = new MediaRecorder(stream, { audioBitsPerSecond: 160000 });

      // 初始化分析器
      analyserRef.current = audioContextRef.current.createAnalyser();
      const source = audioContextRef.current.createMediaStreamSource(stream);
      source.connect(analyserRef.current);
      analyserRef.current.fftSize = 256;

      // 录音数据处理
      mediaRecorder.current.ondataavailable = (event) => {
        audioChunks.current.push(event.data);
      };

      // 录音结束
      mediaRecorder.current.onstop = () => {
        const audioPCM = new File(audioChunks.current, `${dayjs().format('HH:mm:ss')}.mp3`, { type: 'audio/mp3', });
        setFileToPCM(audioPCM)
        audioChunks.current = [];
      };

      mediaRecorder.current.start();
      setIsRecording(true);
      drawWaveform();
    } catch (err) {
      alert('无法访问麦克风，请检查权限设置或麦克风是否可用。');
    }
  }

  const stopRecording = () => { // 停止录音
    if (mediaRecorder.current) {
      mediaRecorder.current.stop()
      setIsRecording(false)
      cancelAnimationFrame(animationRef.current)
      setRecordingTime(0)
    }
  }

  const drawWaveform = () => {// 绘制波形
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const bufferLength = analyserRef.current.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const draw = () => {
      animationRef.current = requestAnimationFrame(draw);
      analyserRef.current.getByteTimeDomainData(dataArray);

      // 清空画布
      ctx.fillStyle = '#141414';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 设置波形样式
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#D32029'
      ctx.beginPath();

      const sliceWidth = (canvas.width * 1.0) / bufferLength;
      let x = 0;

      for (let i = 0; i < bufferLength; i++) {
        // 放大振幅
        const v = dataArray[i] / 128.0;
        const y = (v * canvas.height) / 2;

        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      ctx.lineTo(canvas.width, canvas.height / 2);
      ctx.stroke();
    };

    draw();
  }

  const getUrlBySubFile = async (file) => { //提交 file文件获取url地址
    let res = await getUrlByFileAPI({ access_token: token, file: file })

    if (res.ret !== 200) { message.warning(res.msg || '提交音频文件失败'); return }
    let obj = { url: res.data, time: recordingTimeRef.current }
    list.returnBack(obj)
    recordingTimeRef.current = 0
  }

  const setFileToPCM = async (file) => {//将file文件转换成pcm文件
    const ffmpeg = new FFmpeg();
    try {
      // 加载 FFmpeg
      if (!ffmpeg.loaded) {
        await ffmpeg.load();
      }

      // 将输入文件写入 FFmpeg 文件系统
      await ffmpeg.writeFile('input.mp3', await fetchFile(file));

      // 执行 FFmpeg 命令
      await ffmpeg.exec(['-i', 'input.mp3', '-f', 's16le', '-acodec', 'pcm_s16le', '-ar', '16000', '-ac', '1', '-b:a', '16k', 'out.pcm']);

      // 从 FFmpeg 文件系统中读取输出文件
      const data = await ffmpeg.readFile('out.pcm');

      // 创建 Blob 对象
      const outputBlob = new File([data], `${dayjs().format('HH:mm:ss')}.pcm`, { type: 'audio/pcm', });

      getUrlBySubFile(outputBlob)

    } catch (error) {
      console.error('Error converting file:', error);
    } finally {
      console.log('录制finally');
    }
  }


  useEffect(() => {// 录音时长计时器
    let timer;
    if (isRecording) {
      timer = setInterval(() => {
        recordingTimeRef.current += 1
        localStorage.setItem('megaphoneTime', Math.floor(recordingTimeRef.current / 100))
        setRecordingTime((prevTime) => {
          if (prevTime >= MAX_RECORDING_TIME) {//超过30s
            stopRecording();
            message.warning('录音超过30s,已自动停止')
            return 0;
          }
          return (prevTime + 1);
        });
      }, 10);
    }
    return () => clearInterval(timer);
  }, [isRecording]);

  useEffect(() => {// 初始化音频上下文    
    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)()

    return () => {// 清理资源
      if (audioContextRef.current) { audioContextRef.current.close(); }
      if (animationRef.current) { cancelAnimationFrame(animationRef.current); }
    }
  }, [])

  return (
    <div className='flex jcsb align_center'>

      <>{/* 录音/播放 时间 */}
        <span className='opa25'>
          {recordingTime > 999 ? `00:${recordingTime / 100}` : `00:0${recordingTime / 100}`}
        </span>
      </>

      <>{/* 录音波形声音图 */}
        <canvas
          ref={canvasRef}
          // width="200"
          // height="24"
          className='w200 h24'
          style={{
            borderRadius: '5px',
            display: isRecording ? '' : 'none'
          }}
        />
      </>


      <>{/* 录音按钮 */}
        {
          loading
            ? (
              <LoadingOutlined />
            )
            : isRecording
              ? (
                <img
                  className='pointer'
                  src={ly_f}
                  alt='停止录音'
                  onClick={stopRecording}
                />
              )
              : (
                <img
                  className='pointer'
                  src={ly_t}
                  alt='开始录音'
                  onClick={startRecording}
                />
              )
        }

      </>
    </div>
  );
}

export default AudioRecorder;